// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__28piq","title":"Images90_title__3Bm7g","images":"Images90_images__gSM9F"};